import React, { useCallback, useContext, useRef } from 'react';

export interface RefsContextValue {
  refs: Map<string, React.RefObject<HTMLDivElement>>;
  setRefs: (key: string, ref: React.RefObject<HTMLDivElement>) => void;
  removeRef: (key: string) => void;
}

export const RefsContext = React.createContext<RefsContextValue>({
  refs: new Map(),
  setRefs: () => undefined,
  removeRef: () => undefined
});

const RefsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const refs = useRef<RefsContextValue['refs']>(new Map());

  const setRefs = useCallback((key: string, ref: React.RefObject<HTMLDivElement>) => {
    refs.current.set(key, ref);
  }, []);

  const removeRef = useCallback((key: string) => {
    refs.current.delete(key);
  }, []);

  return (
    <RefsContext.Provider
      value={{
        refs: refs.current,
        setRefs,
        removeRef
      }}
    >
      {children}
    </RefsContext.Provider>
  );
};

export const useRefs = () => useContext(RefsContext);

export default RefsProvider;
